import {
  DefaultLayouts as PatientInfoDefaultLayouts,
  WidgetMetadata as PatientInfoWidgetMetadata,
  DASHBOARD_ID as PATIENT_INFO_DASHBOARD_ID,
} from '../SuperUser/Patients/PatientInfo/PatientInfo';
import {
  getDefaultLayouts as getDevicesDefaultLayouts,
  getWidgetsMetadata as getDevicesWidgetMetadata,
  DASHBOARD_ID as DEVICES_DASHBOARD_ID,
} from './DevicesDashboard';
import {
  DefaultLayouts as RPMDefaultLayouts,
  WidgetMetadata as RPMWidgetMetadata,
  DASHBOARD_ID as RPM_DASHBOARD_ID,
} from './DashboardRPM';
import {
  getDefaultLayouts as getMedicationsDefaultLayouts,
  getWidgetsMetadata as getMedicationsWidgetsMetadata,
  PATIENT_MEDICATION_DASHBOARD_ID_PREFIX,
} from '../SuperUser/Patients/PatientMedications/PatientMedications';
import {
  DefaultLayouts as CohortDetailsDefaultLayouts,
  WidgetMetadata as CohortDetailsWidgetMetadata,
  DASHBOARD_ID as COHORT_DETAILS_DASHBOARD_ID,
} from '../SuperUser/Patients/Cohorts/Cohort';
import {
  DefaultLayouts as SpirometryDefaultLayouts,
  WidgetMetadata as SpirometryWidgetMetadata,
  DASHBOARD_ID as SPIROMETRY_DASHBOARD_ID,
} from '../SuperUser/DeviceManagement/HubDeviceEvents/Graph/Spirometry/SpirometryDashboard';
import {
  DefaultLayouts as AdherenceDefaultLayouts,
  WidgetMetadata as AdherenceWidgetMetadata,
  DASHBOARD_ID as ADHERENCE_DASHBOARD_ID,
} from '../Dashboard/Dashboard';
import {
  PATIENT_DASHBOARD_ID_PREFIX,
  getDefaultLayouts as getPatientDefaultLayouts,
  getWidgetsMetadata as getPatientWidgetsMetadata,
} from '../SuperUser/Patients/Dashboard/PatientDashboard';
import {
  DefaultLayouts as MedicationStatsLayouts,
  MedicationStatsWidgetsMetadata,
  DASHBOARD_ID as MEDICATION_STATS_DASHBOARD_ID,
} from '../SuperUser/Patients/Dashboard/MedicationStats';
import {
  getDefaultLayouts as getReportLayouts,
  getWidgetMetadata as getReportWidgetMetadata,
  DASHBOARD_ID as REPORT_DASHBOARD_ID,
} from '../SuperUser/Report/reportWigetsMetadata';
import {
  getDefaultLayouts as getBusinessReportEnrollmentsLayouts,
  getDeviceUtilizationDefaultLayouts as getBusinessReportDeviceUtilizationLayouts,
  getDeviceUtilizationWidgetMetadata as getBusinessReportDeviceUtilizationWidgetMetadata,
  getOverallDefaultLayouts as getBusinessReportOverallLayouts,
  getOverallWidgetMetadata as getBusinessReportOverallWidgetMetadata,
  getOrganizationsDefaultLayouts as getBusinessReportOrganizationsLayouts,
  getOrganizationsWidgetMetadata as getBusinessReportOrganizationsWidgetMetadata,
  getShipmentsDefaultLayouts as getBusinessReportShipmentsLayouts,
  getShipmentsWidgetMetadata as getBusinessReportShipmentsWidgetMetadata,
  getWidgetMetadata as getBusinessReportEnrollmentsWidgetMetadata,
  DASHBOARD_ID as BUSINESS_REPORT_ENROLLMENTS_DASHBOARD_ID,
  DEVICE_UTILIZATION_DASHBOARD_ID as BUSINESS_REPORT_DEVICE_UTILIZATION_DASHBOARD_ID,
  ORGANIZATIONS_DASHBOARD_ID as BUSINESS_REPORT_ORGANIZATIONS_DASHBOARD_ID,
  OVERALL_DASHBOARD_ID as BUSINESS_REPORT_OVERALL_DASHBOARD_ID,
  SHIPMENTS_DASHBOARD_ID as BUSINESS_REPORT_SHIPMENTS_DASHBOARD_ID,
} from '../SuperUser/BusinessReport/businessReportWidgetsMetadata';
import {
  getOperationalDefaultLayouts as getBusinessReportOperationalLayouts,
  getOperationalWidgetMetadata as getBusinessReportOperationalWidgetMetadata,
  getPerformanceDefaultLayouts as getBusinessReportPerformanceLayouts,
  getPerformanceWidgetMetadata as getBusinessReportPerformanceWidgetMetadata,
  OPERATIONAL_DASHBOARD_ID as BUSINESS_REPORT_OPERATIONAL_DASHBOARD_ID,
  PERFORMANCE_DASHBOARD_ID as BUSINESS_REPORT_PERFORMANCE_DASHBOARD_ID,
} from '../SuperUser/BusinessReport/BusinessReportHighlightsTab';
import {
  DefaultLayouts as AnalyticsDefaultLayouts,
  WidgetMetadata as AnalyticsWidgetMetadata,
  DASHBOARD_ID as ANALYTICS_DASHBOARD_ID,
} from './Analytics';
import {
  DASHBOARD_ID as SUPERUSER_HEALTH_DASHBOARD_ID,
  getDefaultLayouts as getSuperuserHealthDefaultLayouts,
  getWidgetsMetadata as getSuperuserHealthWidgetsMetadata,
} from '../SuperUser/SuperuserHealthCenter/DashboardOverview';

const dashoards = {
  [PATIENT_INFO_DASHBOARD_ID]: {
    defaultLayouts: PatientInfoDefaultLayouts,
    widgets: PatientInfoWidgetMetadata,
  },
  [DEVICES_DASHBOARD_ID]: {
    getLayouts: getDevicesDefaultLayouts,
    getWidgetsMetadata: getDevicesWidgetMetadata,
  },
  [RPM_DASHBOARD_ID]: {
    defaultLayouts: RPMDefaultLayouts,
    widgets: RPMWidgetMetadata,
  },
  [COHORT_DETAILS_DASHBOARD_ID]: {
    defaultLayouts: CohortDetailsDefaultLayouts,
    widgets: CohortDetailsWidgetMetadata,
  },
  [SPIROMETRY_DASHBOARD_ID]: {
    defaultLayouts: SpirometryDefaultLayouts,
    widgets: SpirometryWidgetMetadata,
  },
  [ADHERENCE_DASHBOARD_ID]: {
    defaultLayouts: AdherenceDefaultLayouts,
    widgets: AdherenceWidgetMetadata,
  },
  [MEDICATION_STATS_DASHBOARD_ID]: {
    defaultLayouts: MedicationStatsLayouts,
    widgets: MedicationStatsWidgetsMetadata,
  },
  [REPORT_DASHBOARD_ID]: {
    getLayouts: getReportLayouts,
    getWidgetsMetadata: getReportWidgetMetadata,
  },
  [BUSINESS_REPORT_ENROLLMENTS_DASHBOARD_ID]: {
    getLayouts: getBusinessReportEnrollmentsLayouts,
    getWidgetsMetadata: getBusinessReportEnrollmentsWidgetMetadata,
  },
  [BUSINESS_REPORT_OVERALL_DASHBOARD_ID]: {
    getLayouts: getBusinessReportOverallLayouts,
    getWidgetsMetadata: getBusinessReportOverallWidgetMetadata,
  },
  [BUSINESS_REPORT_OPERATIONAL_DASHBOARD_ID]: {
    getLayouts: getBusinessReportOperationalLayouts,
    getWidgetsMetadata: getBusinessReportOperationalWidgetMetadata,
  },
  [BUSINESS_REPORT_PERFORMANCE_DASHBOARD_ID]: {
    getLayouts: getBusinessReportPerformanceLayouts,
    getWidgetsMetadata: getBusinessReportPerformanceWidgetMetadata,
  },
  [BUSINESS_REPORT_SHIPMENTS_DASHBOARD_ID]: {
    getLayouts: getBusinessReportShipmentsLayouts,
    getWidgetsMetadata: getBusinessReportShipmentsWidgetMetadata,
  },
  [BUSINESS_REPORT_DEVICE_UTILIZATION_DASHBOARD_ID]: {
    getLayouts: getBusinessReportDeviceUtilizationLayouts,
    getWidgetsMetadata: getBusinessReportDeviceUtilizationWidgetMetadata,
  },
  [BUSINESS_REPORT_ORGANIZATIONS_DASHBOARD_ID]: {
    getLayouts: getBusinessReportOrganizationsLayouts,
    getWidgetsMetadata: getBusinessReportOrganizationsWidgetMetadata,
  },
  [PATIENT_MEDICATION_DASHBOARD_ID_PREFIX]: {
    getWidgetsMetadata: getMedicationsWidgetsMetadata,
    getLayouts: getMedicationsDefaultLayouts,
  },
  [PATIENT_DASHBOARD_ID_PREFIX]: {
    getWidgetsMetadata: getPatientWidgetsMetadata,
    getLayouts: getPatientDefaultLayouts,
  },
  [ANALYTICS_DASHBOARD_ID]: {
    defaultLayouts: AnalyticsDefaultLayouts,
    widgets: AnalyticsWidgetMetadata,
  },
  [SUPERUSER_HEALTH_DASHBOARD_ID]: {
    getLayouts: getSuperuserHealthDefaultLayouts,
    getWidgetsMetadata: getSuperuserHealthWidgetsMetadata,
  },
};

function getDashboard(dashboardId) {
  return dashoards[dashboardId] || Object.entries(dashoards).find(([key, value]) => dashboardId.startsWith(key))?.[1];
}

function getAllWidgets(dashboardId, additionalData) {
  const dashboard = getDashboard(dashboardId);
  return dashboard.widgets || dashboard.getWidgetsMetadata(additionalData);
}

export function GetWidgetsVisibility(dashboardId, filters, additionalData, permissions) {
  const allWidgets = getAllWidgets(dashboardId, additionalData);
  const ret = [];
  allWidgets?.forEach(w => {
    const currentState = filters?.find(f => f.id === w.id);
    if (!w.permission || permissions?.includes(w.permission)) {
      ret.push({
        id: w.id,
        label: w.name,
        checked: currentState ? currentState.checked : !w.hiddenByDefault,
        group: w.group,
      });
    }
  });
  return ret;
}

export function GetDefaultFilters(dashboardId, additionalData) {
  const allWidgets = getAllWidgets(dashboardId, additionalData);
  return allWidgets?.map(w => {
    return {
      id: w.id,
      label: w.name,
      checked: !w.hiddenByDefault,
      group: w.group,
    };
  });
}

export function GetDefaultLayouts(dashboardId, additionalData, permissions) {
  const dashboard = getDashboard(dashboardId);
  return dashboard.defaultLayouts || dashboard.getLayouts(additionalData, permissions);
}

export function GetDefaultConfiguration(dashboardId, additionalData) {
  const allWidgets = getAllWidgets(dashboardId, additionalData);
  const ret = {};
  allWidgets?.forEach(w => {
    if (w.configuration) {
      ret[w.id] = {
        ...Object.entries(w.configuration).reduce(
          (acc, [key, value]) => ({ ...acc, [key]: { ...value, value: value.defaultValue } }),
          {},
        ),
      };
    }
  });
  return ret;
}

export function HandleFilterChange(dashboardId, filters, widgetId, visible, additionalData, permissions) {
  const ret = GetWidgetsVisibility(dashboardId, filters, additionalData, permissions);
  ret.find(w => w.id === widgetId).checked = visible;
  return ret;
}

export function GetLayouts(dashboardId, currentFilters, currentLayouts, additionalData, permissions) {
  const defaultLayouts = GetDefaultLayouts(dashboardId, additionalData, permissions);

  const filters = GetWidgetsVisibility(dashboardId, currentFilters, additionalData, permissions);
  const ret = { l: [], m: [], s: [] };

  function getWidget(widget, currentLayout, defaultLayout) {
    const currentWidget = currentLayout && currentLayout.find(w => w.i === widget.id);
    if (currentWidget) {
      const defaultWidget = defaultLayout.find(w => w.i === widget.id);
      const minH = Math.max(currentWidget.minH || 1, defaultWidget?.minH || 1);
      const minW = Math.max(currentWidget.minW || 1, defaultWidget?.minW || 1);
      return {
        ...currentWidget,
        h: Math.max(currentWidget.h, minH),
        w: Math.max(currentWidget.w, minW),
        minH,
        minW,
      };
    }
    return defaultLayout.find(wi => wi.i === widget.id);
  }

  filters
    .filter(w => w.checked === true)
    .forEach(widget => {
      ret.l.push(getWidget(widget, currentLayouts?.l, defaultLayouts.l));
      ret.m.push(getWidget(widget, currentLayouts?.m, defaultLayouts.m));
      ret.s.push(getWidget(widget, currentLayouts?.s, defaultLayouts.s));
  });
  return ret;
}

export function addWidgetToLayouts(dashboardId, layouts, widgetId, additionalData) {
  const allWidgets = getAllWidgets(dashboardId, additionalData);
  const widgetToAdd = allWidgets.find(w => w.id === widgetId);
  const ret = { ...layouts };
  if (widgetToAdd !== undefined && layouts.l.find(l => l.i === widgetToAdd.id) === undefined) {
    ret.l.push({ x: 0, y: 100, ...widgetToAdd.defProps });
    ret.m.push({ x: 0, y: 100, ...widgetToAdd.defProps });
    ret.s.push({ x: 0, y: 100, ...widgetToAdd.defProps });
  }
  return ret;
}
